(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["menglle-membership-float"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('membership-float')) {
    class MembershipFloat extends HTMLElement {
      connectedCallback() {
        this.tab = this.querySelector('.membership-float__tab');
        this.panel = this.querySelector('.membership-float__panel');
        this.closeButton = this.querySelector('.membership-float__close');
        this.startRatio = Number.parseFloat(this.dataset.revealRatio) || 0.35;
        this.autoClose = this.dataset.autoClose === 'true';
        this.autoCloseDelay = Number.parseInt(this.dataset.autoCloseDelay, 10) || 9000;
        this.frame = 0;
        this.idleTimer = 0;

        this.openHandler = () => this.openPanel();
        this.closeHandler = () => this.closePanel();
        this.scheduleHandler = () => this.scheduleReveal();
        this.keyHandler = (event) => this.onKeydown(event);
        this.activityHandler = () => this.resetIdleTimer();
        this.readyHandler = () => this.resolveHero();

        this.tab.addEventListener('click', this.openHandler);
        this.closeButton.addEventListener('click', this.closeHandler);
        this.addEventListener('pointermove', this.activityHandler);
        this.addEventListener('click', this.activityHandler);
        this.addEventListener('focusin', this.activityHandler);
        window.addEventListener('scroll', this.scheduleHandler, { passive: true });
        window.addEventListener('resize', this.scheduleHandler);
        document.addEventListener('keydown', this.keyHandler);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        } else {
          this.resolveHero();
        }
      }

      disconnectedCallback() {
        this.tab.removeEventListener('click', this.openHandler);
        this.closeButton.removeEventListener('click', this.closeHandler);
        this.removeEventListener('pointermove', this.activityHandler);
        this.removeEventListener('click', this.activityHandler);
        this.removeEventListener('focusin', this.activityHandler);
        window.removeEventListener('scroll', this.scheduleHandler);
        window.removeEventListener('resize', this.scheduleHandler);
        document.removeEventListener('keydown', this.keyHandler);
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
        window.cancelAnimationFrame(this.frame);
        window.clearTimeout(this.idleTimer);
      }

      resolveHero() {
        this.hero = document.querySelector('#MainContent [data-section-type="hero"], #MainContent [data-section-type="slideshow"], #MainContent [data-section-type="video"]');
        this.updateReveal();
      }

      scheduleReveal() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.updateReveal();
        });
      }

      updateReveal() {
        let reveal = 1;

        if (this.hero) {
          const rect = this.hero.getBoundingClientRect();
          const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
          const visibleRatio = Math.min(1, visibleHeight / Math.max(1, rect.height));
          reveal = visibleRatio >= this.startRatio ? 0 : Math.min(1, (this.startRatio - visibleRatio) / this.startRatio);
        }

        if (reveal <= 0.001 && this.classList.contains('is-open')) {
          window.clearTimeout(this.idleTimer);
          this.classList.remove('is-open');
          this.panel.hidden = true;
          this.tab.setAttribute('aria-expanded', 'false');
        }

        this.style.setProperty('--membership-reveal', reveal.toFixed(3));
        this.style.setProperty('--membership-shift', `${((1 - reveal) * 24).toFixed(1)}px`);
        this.classList.toggle('is-hidden', reveal <= 0.001);
      }

      openPanel() {
        if (this.classList.contains('is-open')) return;
        this.lastFocus = document.activeElement;
        this.panel.hidden = false;
        this.classList.remove('is-hidden');
        this.classList.add('is-open');
        this.tab.setAttribute('aria-expanded', 'true');
        this.updateReveal();
        this.resetIdleTimer();
        window.requestAnimationFrame(() => this.closeButton.focus());
      }

      closePanel() {
        if (!this.classList.contains('is-open')) return;
        window.clearTimeout(this.idleTimer);
        this.classList.remove('is-open');
        this.panel.hidden = true;
        this.tab.setAttribute('aria-expanded', 'false');
        this.updateReveal();
        if (this.lastFocus instanceof HTMLElement) this.lastFocus.focus();
      }

      resetIdleTimer() {
        if (!this.autoClose || !this.classList.contains('is-open')) return;
        window.clearTimeout(this.idleTimer);
        this.idleTimer = window.setTimeout(() => this.closePanel(), this.autoCloseDelay);
      }

      onKeydown(event) {
        if (!this.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closePanel();
          return;
        }

        this.resetIdleTimer();
        if (event.key !== 'Tab') return;

        const focusable = [...this.panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('membership-float', MembershipFloat);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-design-challenge"] && !Shopify.designMode) return;
  try {
    
  const initDesignOpen = (root) => {
    const sections = root.matches?.('[data-design-open]') ? [root] : root.querySelectorAll?.('[data-design-open]') || [];

    sections.forEach((section) => {
      if (section.dataset.designOpenReady === 'true') return;

      const dialog = section.querySelector('[data-design-open-dialog]');
      if (!dialog) return;

      section.dataset.designOpenReady = 'true';
      section.querySelectorAll('[data-design-open-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => dialog.showModal());
      });
      section.querySelectorAll('[data-design-open-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      if (dialog.querySelector('[data-design-open-auto]')) dialog.showModal();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initDesignOpen(document));
  document.addEventListener('shopify:section:load', (event) => initDesignOpen(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-occasions-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const tab = event.target.closest('.section-collection-tabs .tab-link');
    const header = document.querySelector('[data-occasions-header]');

    if (!tab || !header) return;

    const label = header.querySelector('[data-occasion-label]');
    if (label) label.textContent = tab.textContent.trim();

    const title = header.querySelector('.occasions-header__title');
    if (title && tab.dataset.contextTitle) title.textContent = tab.dataset.contextTitle;
  });

  } catch(e) { console.error(e); }
})();
})();
